import { CapacityAdjustmentRequest, CapacityPeriod } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function adjustCapacity(httpClient: HttpClient) {
  return (request: CapacityAdjustmentRequest) =>
    httpClient.sendHttpRequest<CapacityPeriod>({
      endpoint: "/capacity-planning/capacity/adjustments",
      method: HttpMethods.PUT,
      data: {
        resourceId: request.resourceId,
        from: request.from,
        to: request.to,
        granularity: request.granularity,
        value: request.value,
      },
    });
}

export { adjustCapacity };
